<template>
  <div v-if="isVisible">
    <v-text-field
      :label="schema.label || schema.title"
      :class="fieldClasses"
      :placeholder="schema.placeholder"
      :counter="schema.limit"
      :rules="rules"
      :disabled="isDisabled"
      :error-messages="errorMessages"
      :success-messages="successMessages"
      :readonly="schema.readonly"
      v-model="localValue"
      v-mask="formatInputProps.mask"
      :maxlength="formatInputProps.maxlength"
      :type="formatInputProps.type"
      :inputmode="formatInputProps.inputmode"
      @input="handleChange"
      @blur="handleBlur"
    />
  </div>
</template>

<script>
import GenericField from './GenericField';
import { displayFormat } from '@/lib/fieldFormats';
import { safeMask } from '@/lib/safeMaskDirective';

export default {
  name: 'TextField',
  mixins: [GenericField],
  directives: { mask: safeMask },
  data() {
    return {
      displayValue: null,
    };
  },
  methods: {
    handleChange(val) {
      if (!this.schema.limit || val.length < this.schema.limit) return;
      this.$nextTick(() => {
        this.localValue = val.substring(0, this.schema.limit);
      });
    },
    handleBlur() {
      if (this.resolvedFormat) {
        this.displayValue = displayFormat(
          this.resolvedFormat,
          this.localValue,
          {
            context: 'edit',
          }
        );
      }
      this.$emit('blur');
    },
  },
};
</script>
